
export enum TrainingStatusValue {
  Contact = 'contact',
  Appointed = 'train',
  Inform = 'inform',
  Reschedule = 'reschedule',
  Completed = 'completed',
  Declined = 'declined',
}
